import ActionButton from 'components/ActionButton';
import ImageUploadComponent from 'components/ImageUploadComponent';
import React, { useState } from 'react';
import { addInventoryItemBlog, fetchUrlMetadata } from 'services';
import { imageurlToBase64, isValidURL, showError, showSuccess } from 'utils';
import styles from './index.module.scss';

const AddInventoryItemBlogModal = props => {
  const [title, setTitle] = useState<string>('');
  const [link, setLink] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [urlMetadataLoading, setUrlMetadataLoading] = useState<boolean>(false);
  const [imageForPreview, setImageForPreview] = useState<string>('');
  const [image, setImage] = useState<string | File>();

  const {
    itemId,
    toggleModal,
    onSuccess,
  } = props;

  const createBlog = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await addInventoryItemBlog({
        id: itemId,
        link,
        title,
        image,
      });
      onSuccess(response.toJSON());
      showSuccess('Blog added successfully');
      toggleModal();
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };
  
  const fetchUrlMetadataFn = async () => {
    try {
      setUrlMetadataLoading(true);
      const response = await fetchUrlMetadata(link);
      if (!title) {
        setTitle(response?.title);
      }
      if (!image && !imageForPreview && response?.image) {
        const base64String = await imageurlToBase64(response?.image) as string;
        setImageForPreview(base64String); 
      }
    } catch (e) {
      showError(e);
    } finally {
      setUrlMetadataLoading(false);
    }
  };

  const onImageUpload = (id, image) => {
    setImage(image);
    setImageForPreview(image?._url);
  };
  
  return (
    <div className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            <div className={styles['label']}>Inventory Item</div>
            <div className={styles['modal-title']}>Add Blog</div>
          </div>
          <i className={'fa fa-times'} onClick={toggleModal} />
        </div>
        <div className={styles['modal-body']}>
          <div className={styles['input-group']}>
            <div className={styles['image-container']}>
              <ImageUploadComponent
                src={imageForPreview.toString()}
                entityId={''}
                toggleModal={() => {}}
                uploadAPI={onImageUpload}
                onFileSelect={setImageForPreview}
                forceShowUploadButton
              />
            </div>
          </div>
          <div className='ml-3'>
            <div className={'mb-3'}>
              <div className={styles['label']}>Title</div>
              <input
                className={'form-control'}
                value={title}
                onChange={e => setTitle(e.target.value)}
                disabled={loading}
              />
            </div>
            <div className={styles['input-group']}>
              <div className={styles['label']}>URL</div>
              <div className='d-flex'>
                <input
                  className={'form-control mr-2'}
                  disabled={loading}
                  value={link}
                  onChange={e => setLink(e.target.value)}
                  placeholder='https://blog.puertoricoproduce.com/recetas'
                />
                <ActionButton
                  text={'Fetch'}
                  active={isValidURL(link)}
                  isLoading={urlMetadataLoading}
                  onClick={fetchUrlMetadataFn}
                />
              </div>
            </div>
          </div>
        </div>
        <div className={styles['modal-footer']}>
          <button
            className={styles['cancel-button']}
            type={'button'}
            disabled={loading}
            onClick={toggleModal}
          >
            Cancel
          </button>
          <button
            className={styles['submit-button']}
            disabled={loading || !title || !link || !image}
            onClick={createBlog}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddInventoryItemBlogModal;